import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const adjustLoyaltyPoints = {
  name: "adjustLoyaltyPoints" as const,
  method: "unary" as const,
  input: z.object({
    customerId: zExt.objectId(),
    points: z.number().int(),
    note: z.string().optional(),
  }),
  output: z.void(),
};
